export default __webpack_public_path__ + "static/media/critical-reflection-the-holistic-way.f235f93c.jpg";